import { Injectable } from '@angular/core';
import { CodiceFiscaleService } from './codice-fiscale.service';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ValidationOutcomeDTO } from '../../models/validation-outcome-dto';
import { ConfigurationService } from '../../../configuration/configuration-service';

@Injectable({
	providedIn: 'root'
})
export class CodiceFiscaleServiceImpl extends CodiceFiscaleService {

	urlArgo: string;

	constructor(
		private http: HttpClient,
		private configurationService: ConfigurationService,
	) {
		super();

		console.log('[CodiceFiscaleService]');

		//TODO
		// this.urlArgo = configurationService.servicePaths.get("ARGO_INTEGRATION_MS_API_URL") + "/v1";
		this.urlArgo = configurationService.servicePaths.get("ARGO_INTEGRATION_MS_API_URL") + "/v2";
		console.log('[urlArgo - lib]', this.urlArgo);
	}

	validaCodiceFiscale$(codiceFiscale: string, tipoPersona: string): Observable<ValidationOutcomeDTO> {
		const url: string = this.urlArgo + '/checkfs/cf';
		return this.http.put<ValidationOutcomeDTO>(url, { codiceFiscale, tipoPersona });

		//TODO
		// const url: string = this.paths.get_V1CheckFC();
		// const url: string = this.urlArgo + '/checkfs/cf';
		// return this.http.get<ValidationOutcomeDTO>(url, {
		// 	params: {
		// 		codicefiscale: codiceFiscale,
		// 		tipopersona: tipoPersona
		// 	}
		// });
	}
}